// ags-line-button-controls.ts
import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { ButtonControl } from "appworks/ui/controls/standard/button/button-control";
import { slotModel } from "slotworks/model/slot-model";

export class AgsLineButtonControl extends ButtonControl {
    /**
     * Callback function to handle model updates.
     */
    protected onModelUpdateCallback: Function;
    
    /**
     * Flag indicating whether the button increments or decrements the value.
     */
    protected isIncrement: boolean;

    /**
     * Creates an instance of AgsLineButtonControl.
     * @param {FlexiButton} button - The FlexiButton instance to use.
     * @param {boolean} isIncrement - Flag indicating whether the button increments or decrements the value.
     */
    constructor(button: FlexiButton, isIncrement: boolean) {
        super(button);
        this.isIncrement = isIncrement;
        this.onModelUpdateCallback = () => this.onModelUpdate();
        slotModel.onUpdate.add(this.onModelUpdateCallback);

    }

    /**
     * Cleans up the button and removes event listeners.
     */
    public destroy(): void {
        super.destroy();
        this.button.setVisible(false);
        slotModel.onUpdate.remove(this.onModelUpdateCallback);
    }

    /**
     * Sets whether the button is enabled or disabled.
     * @param {boolean} enabled - Flag indicating whether the button should be enabled.
     */
    public setEnabled(enabled: boolean): void {
        super.setEnabled(enabled);
    }

    /**
     * Handles button click events.
     */
    protected onClick(): void {
        const { winLines } = slotModel.read().bet;
        const currentIndex = winLines.values.findIndex(element => element === winLines.currentValue);

        let nextValue;
        if (this.isIncrement) {
            nextValue = winLines.values[currentIndex + 1] ?? winLines.values[winLines.values.length - 1];
        } 
        else {
            nextValue = winLines.values[currentIndex - 1] ?? winLines.values[0];
        }

        winLines.currentValue = nextValue;
        winLines.lastSelectedValue = nextValue;

        slotModel.write({ bet: { winLines } });
    }

    /**
     * Handles model update events.
     */
    protected onModelUpdate(): void {
        this.setEnabled(this.enabled);
    }
}
